import { render, staticRenderFns } from "./FlapsCouponQueryForm.vue?vue&type=template&id=24ecfc59&scoped=true&"
import script from "./FlapsCouponQueryForm.vue?vue&type=script&lang=js&"
export * from "./FlapsCouponQueryForm.vue?vue&type=script&lang=js&"
import style0 from "./FlapsCouponQueryForm.vue?vue&type=style&index=0&id=24ecfc59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ecfc59",
  null
  
)

export default component.exports